import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useUserRole } from '@/hooks/useUserRole';
import { useBrandManager } from '@/hooks/useBrandManager';

interface OwnerAdminRouteProps {
  children: React.ReactNode;
}

const OwnerAdminRoute = ({ children }: OwnerAdminRouteProps) => {
  const { user, isLoading: authLoading } = useAuth();
  const { currentBrandId } = useBrandManager();
  const { role, isLoading: roleLoading } = useUserRole(currentBrandId);
  const navigate = useNavigate();

  const isLoading = authLoading || roleLoading;

  useEffect(() => {
    // Only proceed if BOTH auth and role checks are completely done
    if (authLoading || roleLoading) {
      return;
    }
    
    if (!user) {
      navigate('/auth');
    } else if (role !== 'owner' && role !== 'admin') {
      navigate('/dashboard');
    }
  }, [user, role, authLoading, roleLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user || (role !== 'owner' && role !== 'admin')) {
    return null;
  }

  return <>{children}</>;
};

export default OwnerAdminRoute;
